export interface IBenefitItems {
  image: {
    url: string;
  }[];
  title: string;
  description: string;
}

export interface IBenefit {
  category: string;
  benefits: IBenefitItems[];
}

export interface IProps {
  title: string;
  benefits: IBenefit[];
}

export enum IButtonFilterTypes {
  ALL = 'all',
  HEALTH = 'health',
  LEARNING = 'learning',
  FINANCE = 'finance',
  OTHER = 'other',
}

export type IButtonFilterType = keyof typeof IButtonFilterTypes;

export interface IButtonFilters {
  text: string;
  value: IButtonFilterTypes;
}

export interface IBenefitBreakpoints {
  mobile: number;
  tablet: number;
  desktop: number;
  all: number;
}
